<script lang="ts">
  const getTraces = async () => {
    const response = await fetch(`https://tendancetrail.fr/wp-json/wp/v2/tracegpx?_fields=id,title,gpx,city`);
    const jsonResponse = await response.json()
    return jsonResponse
  }
  const makeDetailsUrl = (id) => '/details/' + id.toString()
  const traces = getTraces()
  console.log(traces)
</script>

<div class="container max-w-lg flex flex-col">
{#await traces}
  <p class="text-center">Récupération des traces...</p>
  {:then traces}
  {#each traces as trace}
  <div class="gpx-card rounded bg-white p-4 flex justify-between shadow relative">
    <div class="gpx-infos truncate">
      <a class="card-click visited:text-red-600" href={makeDetailsUrl(trace.id)}><h2 class="truncate capitalize">{trace.title.rendered}</h2></a>
      <div class="flex items-center text-gray-500">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <p class="gpx-from capitalize">{trace.city}</p>
      </div>
    </div>
    <div class="flex items-center relative">
      <a href="{trace.gpx}">
        <button class="bg-transparent hover:bg-grey-500 text-blue-700 font-semibold hover:text-white py-2 px-4  border-white hover:border-transparent rounded">
          <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
        </button>
      </a>
    </div>
  </div>
  {/each}
{/await}
</div>
<style>
	h1 {
        color: #00b894;
        font-family: miller-banner, 'BlinkMacSystemFont', -apple-system, 'Roboto', 'Lucida Sans';
        text-transform: uppercase;
        font-size: 2em;
        padding: 10px;
    }

  h2 {
    font-size: 1em;
    font-weight: 600;
  }

  .trace-title {
    width: 100%;
    background: #fff;
  }

  .gpx-card {
    margin-bottom: 20px;
    width: 100%;
  }

  .card-click::after {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .gpx-from {
    font-size: 0.9em;
  }

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
